import { MymachineItem, ShopType } from "./mymachine-response";

const tile = (
    chooseShopMessage: string,
    serviceCaseCreationDisabled: boolean,
    serviceCaseCreateDisabledHeaderText: string,
    serviceCaseCreateDisabledBodyText: string,
    softwareUpdatesAvailable: boolean
) => ({
    number,
    name,
    isFav,
    toggleFavUrl,
    shopLinks = [],
    inProduction,
    image,
    detailLink,
    serviceCallModalLink,
    discontinued,
    softwareUpdates,
}: MymachineItem): string => {
    const renderSoftwareUpdatess = softwareUpdatesAvailable
        ? `
        ${
            softwareUpdates && "state" in softwareUpdates
                ? `software-updates-state="${softwareUpdates.state}"`
                : ""
        }
        ${
            softwareUpdates && "label" in softwareUpdates
                ? `software-updates-label="${softwareUpdates.label}"`
                : ""
        }
    `
        : "";

    return `
        <ux-iws-tile
            ${discontinued ? 'class="is-discontinued"' : ""}
            machine-name="${name}"
            machine-id="${number}"
            machine-image-url="${image}"
            detail-link="${detailLink}"
            service-call-modal-link="${serviceCallModalLink}"
            service-case-creation-disabled="${serviceCaseCreationDisabled}"
            service-case-create-disabled-header-text="${serviceCaseCreateDisabledHeaderText}"
            service-case-create-disabled-body-text="${serviceCaseCreateDisabledBodyText}"
            detail-link="${detailLink}"
            ${inProduction ? `in-production="${inProduction}"` : ""}
            ${renderSoftwareUpdatess}
            ${
                shopLinks && shopLinks.length > 0
                    ? `
                shop-link="${shopLinks[0].link}"
                shop-link-title="${shopLinks[0].linkText}"
                shop-link-icon="${getShopIcon(shopLinks[0].shopType)}"
                shop-link-target="${shopLinks[0].linkTarget}"
            `
                    : ""
            }
            ${
                shopLinks && shopLinks.length > 1
                    ? `
                shop-link-2="${shopLinks[1].link}"
                shop-link-2-title="${shopLinks[1].linkText}"
                shop-link-2-icon="${getShopIcon(shopLinks[1].shopType)}"
                                shop-link-2-target="${shopLinks[1].linkTarget}"
            `
                    : ""
            }
            choose-shop-title="${chooseShopMessage}"
            sync-id="${number}"
            toggle-fav-url="${toggleFavUrl}"
            is-fav="${isFav}"
        >
    ${
        discontinued
            ? `
            <div slot="discontinuation-icon">
                <ux-iws-discontinuation-icon
                    tooltip-identifier="${number}"
                    type="${discontinued.type}"
                    status="${discontinued.status}"
                    extended-support="${discontinued.extendedSupport}"
                ></ux-iws-discontinuation-icon>
                <ux-iws-discontinuation-tooltip
                    tooltip-identifier="${number}"
                    type="${discontinued.type}"
                    status="${discontinued.status}"
                    extended-support="${discontinued.extendedSupport}"
                    head="${discontinued.head}"
                    text="${discontinued.text}"
                    link="${discontinued.link}"
                    link-text="${discontinued.linkText}"
                ></ux-iws-discontinuation-tooltip>
            </div>`
            : ""
    }
        </ux-iws-tile>
    `;
};

const getShopIcon = (type: ShopType) => {
    switch (type) {
        case ShopType.BENDING:
            return "cart-bending-tools";
        case ShopType.PUNCHING:
            return "cart-punching-tools";
        case ShopType.SPAREPARTS:
            return "cart-genuine-parts";
        default:
            return "cart";
    }
};

export default tile;
